import type {FC} from 'react';
import {
  Box,
  Divider,
  Icon,
  IconNames,
  Stack,
  Typography,
} from '@wellstone-solutions/web';
import {Theme, Modules} from '@wellstone-solutions/common';
import type {UICalendarEventType} from '@wellstone-solutions/common';
import {REMINDER_INTERVALS} from 'modules/group/constants';
import {GroupEventLocation} from './GroupEventLocation';

interface GroupEventContentType {
  calendarEvent: UICalendarEventType;
}

export const GroupEventContent: FC<GroupEventContentType> = ({
  calendarEvent,
}) => {
  const {displayDate, displayTime} = Modules.Schedule.useRecurrenceDisplayText({
    calendarEvent,
    hideRecurrence: calendarEvent.data?.override ?? false,
  });

  const {invitations} = calendarEvent;

  // There's a delay for invitations getting added to new group events, so just avoid rendering reminder label if not defined, yet
  const hasInvitations = invitations.length > 0;
  let reminderLabel = '';

  if (hasInvitations) {
    const {reminderTime} = invitations[0];
    const reminderInterval = REMINDER_INTERVALS.find(
      (interval) => interval.value === reminderTime,
    );
    // Hack to get invitation level field on group event. There's always an owner invitation
    reminderLabel = `Reminder ${reminderInterval?.label} ${reminderInterval?.interval} before`;
  }

  return (
    <Stack direction={'row'} sx={{width: '100%', mt: 1}}>
      <Box sx={{mr: 1}}>
        <Icon name={IconNames.Calendar} color={Theme.colorPalette.dark} />
      </Box>
      <Stack sx={{width: '40%'}}>
        <Typography sx={{fontWeight: 'bold'}}>{displayDate}</Typography>
        <Typography>{displayTime}</Typography>
        {hasInvitations && <Typography>{reminderLabel}</Typography>}
      </Stack>
      <Divider orientation="vertical" sx={{mx: 4}} />
      <GroupEventLocation calendarEvent={calendarEvent} />
    </Stack>
  );
};
